import { Product } from '@/models/Product';


export class SmartphoneService {

	getAndroidOffers(): Product[] {
		return [{
			asin: 'AND_01',
			price: '113.87',
			rating: 4.7,
			reviewCount: 66,
			text: 'Unlocked LG G6 5.7" 4G Android 4GB/32GB IPS Spadragon 821',
			produced: 'LG Mobile',
			link: 'http://s.click.aliexpress.com/e/bvNaumYo',
			images: [
				'https://ae01.alicdn.com/kf/HTB1OtvzXu6sK1RjSsrbq6xbDXXas/Unlocked-LG-G6-H870-H871-VS988-Mobile-Phone-5-7-inch-Quad-Core-Android-Phone-4GB.jpg',
				'https://ae01.alicdn.com/kf/HTB1wdzAXsfrK1RjSszcq6xGGFXa8/Unlocked-LG-G6-H870-H871-VS988-Mobile-Phone-5-7-inch-Quad-Core-Android-Phone-4GB.jpg',
				'https://ae01.alicdn.com/kf/HTB1CLHzXynrK1Rjy1Xcq6yeDVXah/Unlocked-LG-G6-H870-H871-VS988-Mobile-Phone-5-7-inch-Quad-Core-Android-Phone-4GB.jpg'
			]
		},{
			asin: 'AND_02',
			price: '270.00',
			rating: 4.9,
			reviewCount: 16,
			text: 'LG V30+ 6.0" 4G Android 64GB/128GB Amoled Spadragon 835',
			produced: 'LG Mobile',
			link: 'http://s.click.aliexpress.com/e/BXqwMWU',
			images: [
				'https://ae01.alicdn.com/kf/HTB1FOO5CL9TBuNjy1zbq6xpepXau/Original-Unlocked-LG-V30-6-0-Qualcomm835-Octa-Core-4GB-RAM-64GB-128GB-ROM-dual-back.jpg',
				'https://ae01.alicdn.com/kf/HTB1JRu0kf6TBKNjSZJiq6zKVFXab/Original-Unlocked-LG-V30-6-0-Qualcomm835-Octa-Core-4GB-RAM-64GB-128GB-ROM-dual-back.jpg',
				'https://ae01.alicdn.com/kf/HTB1oEnrCH1YBuNjSszhq6AUsFXa5/Original-Unlocked-LG-V30-6-0-Qualcomm835-Octa-Core-4GB-RAM-64GB-128GB-ROM-dual-back.jpg'
			]
		}];
	}
}
